import { render, staticRenderFns } from "./VMasksDialogChange.vue?vue&type=template&id=3979e478"
import script from "./VMasksDialogChange.vue?vue&type=script&lang=js"
export * from "./VMasksDialogChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports